<script lang="ts" setup>
    import { ref, computed, onMounted, watch } from "vue";
    import SearchUserGroup  from './SearchUserGroup.vue';
    import { IListByNameExtended } from '../../lib/Models/SearchModel';
    import { AppScreenNames, ListNames } from '../../Enums/ChoiceEnums';
    import SelectMultiple from "../SelectMultiple.vue";

    //const emit = defineEmits(["onSelected", "onChange"]);
    const emit = defineEmits<{
        (e: "onSelected", selectedResults: IListByNameExtended[]): void,
        (e: "onChange", listResults: IListByNameExtended[]): void        
    }>();

    const props = withDefaults(defineProps<{
        // Placeholder text to be displayed inside text control if no values
        placeholder?: string,
        // Label for the component
        label?: string,
        // The maximum height of the search results
        maxSearchHeight?: number,
        // The default list
        defaultListName?: ListNames,
        // Base Class
        addToBaseClass?: string,
        addDefaultList?: IListByNameExtended[]
    }>(), {
        placeholder: "Search User/Group",
        label: "User/Group",
        defaultListName: ListNames.Empty,
        addToBaseClass: ""
    });

    onMounted(async () => {    

    });

    const searchResults = ref<IListByNameExtended>();
    const componentKey = ref<number>(0);
    const resetFocus = ref<boolean>(false);

    const displayLabel = computed<boolean>(() => props.label.length > 0 ? true : false);
    const defaultAddToBaseClass = computed<string>(() => props.addToBaseClass);

    function onSearchSelect(selectedItem: IListByNameExtended) {
        selectedItem.selected = true;
        searchResults.value = selectedItem;
        resetFocus.value = true;
        componentKey.value += 1;
    }

    function onSelected(selectedResults: IListByNameExtended[]) {
        emit("onSelected", selectedResults);
    }

    function onChange(listResults: IListByNameExtended[]) {
        emit("onChange", listResults);
    }
</script>

<template>
    <label v-if="displayLabel" :class="defaultAddToBaseClass">{{label}}</label>
    <SelectMultiple
        :maxHeight=200
        :listName="defaultListName"
        :addToList="searchResults"
        :addDefaultList="addDefaultList"
        :addToBaseClass="defaultAddToBaseClass"
        @onSelected="onSelected"
        @onChange="onChange">
    </SelectMultiple>
    <SearchUserGroup 
        :key="componentKey"
        :placeholder="placeholder"
        label=""
        :maxHeight="maxSearchHeight"
        :screenName="AppScreenNames.ToDoDocReview"
        :resetFocus="resetFocus"
        :addToBaseClass="defaultAddToBaseClass"
        @onChange="onSearchSelect">
    </SearchUserGroup>
</template>